// QRScanner.js
import React, { useState } from 'react';
import QrReader from 'react-qr-reader';
import styles from './QRScanner.module.scss';
import { Badge, Modal } from 'react-bootstrap';
import Spinner from '../Spinner/Spinner';
import useKioskLogin from '../../hooks/useKioskLogin';
import { KIOSK_LOGIN_FAILED_MESSAGE, KIOSK_LOGIN_SUCCESS_MESSAGE } from '../../constants';

type QRScanner = {
  showModal: boolean;
  closeModal: () => void;
  openResponseModal: () => void;
  removeKioskHistoryState: () => void;
  history:any;
};

const QRScanner = (props: QRScanner) => {
  const { showModal, closeModal, openResponseModal, removeKioskHistoryState, history } = props;

  const {kioskLoginAuthenticatedUser, removeKioskLoginSession} = useKioskLogin();

  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleScan = async (data) => {
    if (data) {
      setResult(data);
      try {
      const response = await kioskLoginAuthenticatedUser({link:data});
      if (response.data.status) {
        const newStates = history.location.state;
        newStates.status = true;
        newStates.message = KIOSK_LOGIN_SUCCESS_MESSAGE
        history.replace({
          ...history.location,
          state: newStates,
        });
      }else{
        const newStates = history.location.state;
        newStates.status = false;
        newStates.message = KIOSK_LOGIN_FAILED_MESSAGE
        history.replace({
          ...history.location,
          state: newStates,
        });
      }
      } catch (error) {
        const newStates = history.location.state;
        newStates.status = false;
        newStates.message = KIOSK_LOGIN_FAILED_MESSAGE
        history.replace({
          ...history.location,
          state: newStates,
        });
      }
      setResult(null);
      closeModal();
      openResponseModal();
    }
  };

  const handleError = (err) => {
    setError(err);
    const newStates = history.location.state;
    newStates.status = false;
    newStates.message = KIOSK_LOGIN_FAILED_MESSAGE
    history.replace({
      ...history.location,
      state: newStates,
    });
    setResult(null);
    closeModal();
    openResponseModal();
  };

  const handleCloseModal = () => {
    removeKioskLoginSession();
    removeKioskHistoryState();
    closeModal();
  }

  return (
    <Modal
      show={showModal}
      centered
      className="theme-modal-style app_container_wrap border-radius-15 px-5 order_type_modal"
      onHide={handleCloseModal}
    >
      <Modal.Header className="x-4 justify-content-center">
        <button
          type="button"
          className="btn modal-close-button pe-0"
          onClick={handleCloseModal}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className={`${styles.scanner_container}`}>
          <h2>Scan Barcode</h2>
          <span className="f-w5 f-s12 ms-md-2 font-rale mb-1 mt-1 text-center mx-4">
            scan the barcode found at Kiosk app to add reward points to your
            account.
          </span>
          {result ? (
            <div className="py-5 d-flex justify-content-center">
              <Spinner className={styles.modal_spinner} showFooter={'d-none'} />
            </div>
          ) : (
            <div className={`${styles.scanner}`}>
              <QrReader
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: '100%' }}
                className={`${styles.qrCodeScanner}`}
              />
              <div className={`${styles.scanner_overlay}`}>
                <div className={`${styles.scanner_border}`} />
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default QRScanner;
